import axios from 'axios'
import * as Config from '../config'
import { data } from 'autoprefixer'
import FormData from 'form-data'
import { ContactlessOutlined } from '@mui/icons-material'
// import fs from 'fs'

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 1000000,
})

const multiPartInstance = axios.create({
  timeout: 1000000,
})
// add by admin

multiPartInstance.interceptors.request.use(function (config) {
  const token = localStorage.getItem('adminToken')
  config.headers.Authorization = `Bearer ${token}`

  return config
})

instance.interceptors.request.use(function (config) {
  const token = localStorage.getItem('adminToken')
  config.headers.Authorization = `Bearer ${token}`

  return config
})

instance.interceptors.request.use(
  (request) => {
    return request
  },
  (error) => {
    return Promise.reject(error)
  },
)

export const API = {
  commonApi: {
    //upload image
    postImage: (props) =>
      axios.post(`${Config.UPLOAD_IMAGE}?s3_path=${props.path}`, props.data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
  },
  settingApi: {
    //Banner
    getBanner: () => instance.get(Config.BANNER),
    deleteBanner: (id) => instance.delete(`${Config.BANNER}${id}/`),
    updateBanner: (props) => instance.put(`${Config.BANNER}${props.id}/`, props.data),
    addBanner: (data) => instance.post(Config.BANNER, data),
    // //speciality
    // speciality: () => instance.get(Config.SPECIALITY),
    // deleteSpeciality: (id) => instance.delete(`${Config.SPECIALITY}${id}`),
    // updateSpeciality: (props) => instance.put(`${Config.SPECIALITY}${props.id}`, props.data),

    stateList: (data) => {
      let url = Config.STATE // Adjust this if necessary
      let queryString = ''

      if (data) {
        if (typeof data === 'number' || (typeof data === 'string' && !isNaN(data))) {
          // If data is a numeric ID or string representing a number
          url += `/${data}`
        } else if (typeof data === 'object' && data !== null) {
          // If data is an object, handle pagination and additional parameters
          const { page, pageSize, urlAddOn } = data

          if (page !== undefined && page !== '') {
            queryString += `page=${page}`
          }

          if (pageSize !== undefined && pageSize !== '') {
            if (queryString) {
              queryString += '&'
            }
            queryString += `size=${pageSize}`
          }

          let formattedUrlAddOn = ''
          if (urlAddOn && urlAddOn.trim() !== '') {
            if (queryString) {
              formattedUrlAddOn = `&${urlAddOn.startsWith('&') ? urlAddOn.slice(1) : urlAddOn}`
            } else {
              formattedUrlAddOn = urlAddOn
            }
          }

          queryString += formattedUrlAddOn
        }
      }

      const finalUrl = queryString ? `${url}?${queryString}` : url

      return instance.get(finalUrl)
    },

    deleteState: ({ id }) => instance.delete(`${Config.STATE}${id}`),
    updateState: ({ id, ...data }) => instance.put(`${Config.STATE}${id}`, data),
    addState: (data) => instance.post(Config.STATE, data),

    districtListApi: (data) => {
      let url = Config.DISTRICT_LIST
      let queryString = ''

      // Check if data is present
      if (data) {
        // Check if data is a number or a string representing a number
        if (typeof data === 'number' || (typeof data === 'string' && !isNaN(data))) {
          // Append the numeric ID to the URL
          url += `${data}`
        } else if (typeof data === 'object' && data !== null) {
          // Destructure data if it's an object
          const { page, pageSize, urlAddOn } = data

          // Add page parameter if it exists and is not empty
          if (page !== undefined && page !== '') {
            queryString += `page=${page}`
          }

          // Add size parameter if it exists and is not empty
          if (pageSize !== undefined && pageSize !== '') {
            if (queryString) {
              queryString += '&' // Append '&' if there's already a query string
            }
            queryString += `size=${pageSize}`
          }

          // Format urlAddOn correctly
          let formattedUrlAddOn = ''
          if (urlAddOn && urlAddOn.trim() !== '') {
            if (queryString) {
              // Ensure urlAddOn starts with '&' if queryString is already present
              formattedUrlAddOn = `&${urlAddOn.startsWith('&') ? urlAddOn.slice(1) : urlAddOn}`
            } else {
              formattedUrlAddOn = urlAddOn
            }
          }

          // Combine queryString with urlAddOn
          queryString += formattedUrlAddOn
        }
      }

      // Construct the final URL with or without query string
      const finalUrl = queryString ? `${url}?${queryString}` : url

      // Make the API call
      return instance.get(finalUrl)
    },

    deleteDistrict: ({ id }) => instance.delete(`${Config.DISTRICT_LIST}${id}`),
    updateDistrict: ({ id, ...data }) => instance.put(`${Config.DISTRICT_LIST}${id}`, data),
    addDistrict: (data) => instance.post(Config.DISTRICT_LIST, data),

    // Taluk

    talukListApi: (data) => {
      let url = Config.TALUK
      let queryString = ''

      // Check if data is present
      if (data) {
        // Check if data is a number or a string representing a number
        if (typeof data === 'number' || (typeof data === 'string' && !isNaN(data))) {
          // Append the numeric ID to the URL
          url += `${data}`
        } else if (typeof data === 'object' && data !== null) {
          // Destructure data if it's an object
          const { page, pageSize, urlAddOn } = data

          // Add page parameter if it exists and is not empty
          if (page !== undefined && page !== '') {
            queryString += `page=${page}`
          }

          // Add size parameter if it exists and is not empty
          if (pageSize !== undefined && pageSize !== '') {
            if (queryString) {
              queryString += '&' // Append '&' if there's already a query string
            }
            queryString += `size=${pageSize}`
          }

          // Format urlAddOn correctly
          let formattedUrlAddOn = ''
          if (urlAddOn && urlAddOn.trim() !== '') {
            if (queryString) {
              // Ensure urlAddOn starts with '&' if queryString is already present
              formattedUrlAddOn = `&${urlAddOn.startsWith('&') ? urlAddOn.slice(1) : urlAddOn}`
            } else {
              formattedUrlAddOn = urlAddOn
            }
          }

          // Combine queryString with urlAddOn
          queryString += formattedUrlAddOn
        }
      }

      // Construct the final URL with or without query string
      const finalUrl = queryString ? `${url}?${queryString}` : url

      // Make the API call
      return instance.get(finalUrl)
    },

    addTaluk: (data) => instance.post(Config.TALUK, data),
    updateTaluk: ({ id, ...data }) => instance.put(`${Config.TALUK}${id}`, data),
    deleteTaluk: ({ id }) => instance.delete(`${Config.TALUK}${id}`),
    talukDetails: (data) => instance.get(`${Config.TALUK}${data.id}/`),
  },
  authApi: {
    loginApi: ({ data, headers }) => instance.post(Config.LOGIN, data, { headers }),
  },
  providerManagementApi: {
    userListApi: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.USER_LIST}${queryString}`)
    },
    getUserDetailsList: (id) => instance.get(`${Config.USER_LIST}${id}/`),

    storeList: (data) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.STORE}${queryString}`
      return instance.get(url)
    },
    getStoreDetailsList: (id) => instance.get(`${Config.STORE}${id}`),
    addStoreByAdmin: (data) => instance.post(`${Config.STORE}?is_added_by_admin=true`, data),
    updateStoreByAdmin: ({ id, ...data }) => instance.put(`${Config.STORE}${id}`, data),
    deleteStore: ({ id }) => instance.delete(`${Config.STORE}${id}/`),
    activateStore: (id) => instance.put(`${Config.ACTIVATE_STORE}${id}/`),
    deActiveStore: (id) => instance.put(`${Config.DEACTIVATE_STORE}${id}/`),
    addBulkStoreByExcel: ({ params, formDataToSubmit }) => {
      // Construct the base URL with state_id and city_id
      let url = `${Config.ADD_BULK_STORE_BY_EXCEL}?state_id=${params.state_id}&city_id=${params.city_id}`
      // Conditionally add taluk_id to the URL if it is not null or empty
      if (params.taluk_id) {
        url += `&taluk_id=${params.taluk_id}`
      }
      // Send the POST request with the multipart form data
      return multiPartInstance.post(url, formDataToSubmit, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
    // Company List
    companyList: (data) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.STORE}${queryString}`
      return instance.get(url)
    },
    getCompanyDetailsList: (id) => instance.get(`${Config.STORE}${id}`),
    addCompanyByAdmin: (data) => instance.post(`${Config.STORE}?is_added_by_admin=true`, data),
    updateCompanyByAdmin: ({ id, ...data }) => instance.put(`${Config.STORE}${id}`, data),
    deleteCompany: ({ id }) => instance.delete(`${Config.STORE}${id}/`),
    activateCompany: (id) => instance.put(`${Config.ACTIVATE_STORE}${id}/`),
    deActiveCompany: (id) => instance.put(`${Config.DEACTIVATE_STORE}${id}/`),

    // DistriButer

    distributorList: (data) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.STORE}${queryString}`
      return instance.get(url)
    },
    getDistributorDetailsList: (id) => instance.get(`${Config.STORE}${id}`),
    addDistributorByAdmin: (data) => instance.post(`${Config.STORE}?is_added_by_admin=true`, data),
    updateDistributorByAdmin: ({ id, ...data }) => instance.put(`${Config.STORE}${id}`, data),
    deleteDistributor: ({ id }) => instance.delete(`${Config.STORE}${id}/`),
    activateDistributor: (id) => instance.put(`${Config.ACTIVATE_STORE}${id}/`),
    deActiveDistributor: (id) => instance.put(`${Config.DEACTIVATE_STORE}${id}/`),
  },

  storeManagement: {
    // Store Roles
    storeRolesList: (data) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.LIST_STORE_ROLES}${queryString}`
      return instance.get(url)
    },

    addStoreRoles: (data) => instance.post(Config.ADD_STORE_ROLES, data),
    updateStoreRoles: ({ id, ...data }) => instance.put(`${Config.UPDATE_STORE_ROLES}${id}/`, data),

    // Store Category
    storeCategoriesList: (data) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.LIST_PRODUCT_CATEGORY}${queryString}`
      return instance.get(url)
    },
    storeCategoryDetails: ({ id }) =>
      instance.get(`${Config.LIST_PRODUCT_CATEGORY}?product_category_id=${id}`),
    addStoreCategory: (data) => instance.post(Config.ADD_PRODUCT_CATEGORY, data),
    updateStoreCategoryList: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_PRODUCT_CATEGORY}${id}/`, data),
    deleteStoreProductCategoryData: ({ id }) =>
      instance.delete(`${Config.DELETE_PRODUCT_CATEGORY}${id}/`),

    storeSubCategoryList: (data) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.LIST_SUB_PRODUCT_CATEGORY}${queryString}`
      return instance.get(url)
    },
    storeSubCategoryDetails: ({ id }) =>
      instance.get(`${Config.LIST_SUB_PRODUCT_CATEGORY}?product_sub_category_id=${id}`),
    addSubStoreCategory: (data) => instance.post(Config.ADD_SUB_PRODUCT_CATEGORY, data),
    updateStoreSubCategoryList: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_SUB_PRODUCT_CATEGORY}${id}/`, data),
    deleteStoreSubProductCategory: ({ id }) =>
      instance.delete(`${Config.DELETE_SUB_PRODUCT_CATEGORY}${id}/`),

    getStoreTypeList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.STORE_TYPE_URL}${queryString}`
      return instance.get(url)
    },
    addStoreTypeList: (data) => instance.post(Config.STORE_TYPE_URL, data),
    updateStoreTypeList: ({ id, ...data }) => instance.put(`${Config.STORE_TYPE_URL}${id}/`, data),
    deleteStoreTypeList: ({ id }) => instance.delete(`${Config.STORE_TYPE_URL}${id}/`),
    getStoreTypeDetailsList: (id) => instance.get(`${Config.STORE_TYPE_URL}${id}/`),

    storeProductSubChildCategoriesList: (data) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.PRODUCT_CHILD_SUB_CATEGORY_LIST}${queryString}`
      return instance.get(url)
    },
    storeProductSubChildCategoriesItemDetails: ({ id }) =>
      instance.get(`${Config.PRODUCT_CHILD_SUB_CATEGORY_LIST}?product_child_sub_category_id=${id}`),
    addStoreProductChildSubCategory: (data) =>
      instance.post(Config.ADD_PRODUCT_CHILD_SUB_CATEGORY_LIST, data),
    updateStoreChildSubCategoryList: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_PRODUCT_CHILD_SUB_CATEGORY_LIST}${id}/`, data),
    deleteStoreProductChildSubCategory: ({ id }) =>
      instance.delete(`${Config.DELETE_PRODUCT_CHILD_SUB_CATEGORY_LIST}${id}/`),

    // Admin Brand

    brandList: (data) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.BRAND_URL}${queryString}`
      return instance.get(url)
    },
    brandNameDetails: ({ id }) => instance.get(`${Config.BRAND_URL}${id}/`),

    addBrand: (data) => instance.post(Config.BRAND_URL, data),
    updateBrand: ({ id, ...data }) => instance.put(`${Config.BRAND_URL}${id}/`, data),
    deleteBrand: ({ id }) => instance.delete(`${Config.BRAND_URL}${id}/`),

    // Admin Store Group
    getStoreGroupList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.ADMIN_STORE_GROUP_LIST}${queryString}`
      return instance.get(url)
    },
    addStoreGroupList: (data) => instance.post(Config.ADD_STORE_GROUP, data),
    updateStoreGroupList: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_STORE_GROUP}${id}/`, data),
    activeInactiveStoreGroupList: ({ id, is_active }) =>
      instance.patch(`${Config.ACTIVE_INACTIVE_STORE_GROUP}${id}/?activate=${is_active}`),

    deleteStoreGroup: ({ id }) => instance.delete(`${Config.STORE_GROUP_DELETE}${id}/`),
    getStoreGroupDetailsList: (id) => instance.get(`${Config.ADMIN_STORE_GROUP_DETAILS}${id}/`),

    // Store Tag
    getStoreTagList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.STORE_TAG_LIST}${queryString}`
      return instance.get(url)
    },
    addStoreTag: (data) => instance.post(Config.ADD_STORE_TAG, data),
    updateStoreTag: ({ id, ...data }) => instance.put(`${Config.UPDATE_STORE_TAG}${id}/`, data),
    deleteStoreTag: ({ id }) => instance.delete(`${Config.DELETE_STORE_TAG}${id}/`),
    activeInactiveStoreTagList: ({ id, is_active }) =>
      instance.patch(`${Config.STORE_TAG_ACTIVE_INACTIVE}${id}/?activate=${is_active}`),

    activeInactiveStoreRolesList: ({ id, is_active }) =>
      instance.patch(`${Config.STORE_ROLES_ACTIVE_INACTIVE}${id}/?activate=${is_active}`),
    activeInactiveStoreTypeList: ({ id, is_active }) =>
      instance.patch(`${Config.STORE_TYPE_ACTIVE_INACTIVE}${id}/?activate=${is_active}`),

    getEnguiryList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.ENQUIRY_LIST}${queryString}`
      return instance.get(url)
    },
    getEnquiryDetailsList: (id) => instance.get(`${Config.ENQUIRY_LIST}?id=${id}`),

    storeVideo: {
      // ================= Video Categories =================

      getVideoCategoryList: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data
        let queryParams = []
        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
        return instance.get(`${Config.STORE_VIDEO_CATEGORY_LIST}${queryString}`)
      },

      addVideoCategory: (data) => instance.post(Config.ADD_STORE_VIDEO_CATEGORY, data),

      updateVideoCategory: ({ id, ...data }) =>
        instance.put(`${Config.UPDATE_STORE_VIDEO_CATEGORY}${id}/`, data),

      activeInactiveVideoCategory: ({ id, is_active }) =>
        instance.patch(
          `${Config.STORE_VIDEO_CATEGORY_ACTIVE_INACTIVE}${id}/?activate=${is_active}`,
        ),

      // ================= Store Videos =================

      getVideoList: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data
        let queryParams = []
        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
        return instance.get(`${Config.STORE_VIDEO_LIST}${queryString}`)
      },

      getVideoDetails: ({ id }) => instance.get(`${Config.STORE_VIDEO_LIST_DETAILED}${id}`),

      addVideo: (data) => instance.post(Config.ADD_STORE_VIDEO, data),

      updateVideo: ({ id, ...data }) => instance.put(`${Config.UPDATE_STORE_VIDEO}${id}/`, data),

      activeInactiveVideo: ({ id, is_active }) =>
        instance.patch(`${Config.STORE_VIDEO_ACTIVE_INACTIVE}${id}/?activate=${is_active}`),
    },

    internshipManagement: {
      // ================= Internship Super Category =================
      getInternshipSuperCategoryList: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data
        let queryParams = []
        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)
        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
        return instance.get(`${Config.INTERNSHIP_PROGRAM_SUPER_CATEGORY}${queryString}`)
      },

      getInternshipSuperCategoryDetails: ({ id }) =>
        instance.get(`${Config.INTERNSHIP_PROGRAM_SUPER_CATEGORY}${id}/`),

      addInternshipSuperCategory: (data) =>
        instance.post(Config.INTERNSHIP_PROGRAM_SUPER_CATEGORY, data),

      updateInternshipSuperCategory: ({ id, ...data }) =>
        instance.put(`${Config.INTERNSHIP_PROGRAM_SUPER_CATEGORY}${id}/`, data),

      deleteInternshipSuperCategory: ({ id }) =>
        instance.delete(`${Config.INTERNSHIP_PROGRAM_SUPER_CATEGORY}${id}/`),

      activeInactiveInternshipSuperCategory: ({ id, is_active }) =>
        instance.patch(
          `${Config.INTERNSHIP_PROGRAM_SUPER_CATEGORY}${id}/status?activate=${is_active}`,
        ),
      // ================= Internship Category =================

      getInternshipCategoryList: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data

        let queryParams = []
        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''

        return instance.get(`${Config.INTERNSHIP_PROGRAM_CATEGORY}${queryString}`)
      },

      addInternshipCategory: (data) => instance.post(Config.INTERNSHIP_PROGRAM_CATEGORY, data),

      updateInternshipCategory: ({ id, ...data }) =>
        instance.put(`${Config.INTERNSHIP_PROGRAM_CATEGORY}${id}/`, data),

      activeInactiveInternshipCategory: ({ id, is_active }) =>
        instance.patch(`${Config.INTERNSHIP_PROGRAM_CATEGORY}${id}/status?activate=${is_active}`),
      deleteInternshipCategory: ({ id }) =>
        instance.delete(`${Config.INTERNSHIP_PROGRAM_CATEGORY}${id}/`),

      // ================= Internship Sub Category =================

      getInternshipSubCategoryList: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data

        let queryParams = []
        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''

        return instance.get(`${Config.INTERNSHIP_PROGRAM_SUBCATEGORY}${queryString}`)
      },

      addInternshipSubCategory: (data) =>
        instance.post(Config.INTERNSHIP_PROGRAM_SUBCATEGORY, data),

      updateInternshipSubCategory: ({ id, ...data }) =>
        instance.put(`${Config.INTERNSHIP_PROGRAM_SUBCATEGORY}${id}/`, data),

      activeInactiveInternshipSubCategory: ({ id, is_active }) =>
        instance.patch(
          `${Config.INTERNSHIP_PROGRAM_SUBCATEGORY}${id}/status?activate=${is_active}`,
        ),

      deleteInternshipSubCategory: ({ id }) =>
        instance.delete(`${Config.INTERNSHIP_PROGRAM_SUBCATEGORY}${id}/`),

      // ================= Internship Programs =================

      getInternshipProgramList: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data

        let queryParams = []
        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''

        return instance.get(`${Config.INTERNSHIP_PROGRAM}${queryString}`)
      },

      getInternshipProgramDetails: (id) => instance.get(`${Config.INTERNSHIP_PROGRAM}${id}/`),
      deleteInternshipProgram: ({ id }) => instance.delete(`${Config.INTERNSHIP_PROGRAM}${id}/`),

      // ================= Applied Internship =================

      getAppliedInternshipList: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data

        let queryParams = []
        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''

        return instance.get(`${Config.INTERNSHIP_PROGRAM_APPLIED_LIST}${queryString}`)
      },
    },

    // ================= Offer Category =================
    offer: {
      // List Offer Categories
      getOfferCategoryList: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data
        let queryParams = []

        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
        const url = `${Config.OFFER_CATEGORY_LIST}${queryString}`

        return instance.get(url)
      },

      // Get Offer Category Details by ID
      getOfferCategoryDetails: ({ id }) => instance.get(`${Config.OFFER_CATEGORY_DETAILS}${id}`),

      // Add Offer Category
      addOfferCategory: (data) => instance.post(Config.ADD_OFFER_CATEGORY, data),

      // Update Offer Category
      updateOfferCategory: ({ id, ...data }) =>
        instance.put(`${Config.UPDATE_OFFER_CATEGORY}${id}`, data),

      // Activate / Deactivate Offer Category
      activeInactiveOfferCategory: ({ id, is_active }) =>
        instance.patch(`${Config.OFFER_CATEGORY_ACTIVE_INACTIVE}${id}?activate=${is_active}`),
      getStoreOfferList: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data
        let queryParams = []

        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
        return instance.get(`${Config.STORE_OFFER_LIST}${queryString}`)
      },
      // ✅ DETAILS (View)
      getStoreOfferDetails: ({ id }) => {
        return instance.get(`${Config.STORE_OFFER_DETAILS}${id}/`)
      },
      // ✅ UPDATE OFFER
      updateStoreOffer: ({ id, data }) => {
        return instance.put(`${Config.UPDATE_STORE_OFFER}${id}/`, data)
      },

      // LIST
      getOfferSubCategoryList: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data
        let queryParams = []

        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
        return instance.get(`${Config.OFFER_SUBCATEGORY_LIST}${queryString}`)
      },

      // DETAILS
      getOfferSubCategoryDetails: ({ id }) =>
        instance.get(`${Config.OFFER_SUBCATEGORY_DETAILS}${id}`),

      // ADD
      addOfferSubCategory: (data) => instance.post(Config.ADD_OFFER_SUBCATEGORY, data),

      // UPDATE
      updateOfferSubCategory: ({ id, ...data }) =>
        instance.put(`${Config.UPDATE_OFFER_SUBCATEGORY}${id}`, data),

      // ACTIVE / INACTIVE
      activeInactiveOfferSubCategory: ({ id, is_active }) =>
        instance.patch(`${Config.OFFER_SUBCATEGORY_ACTIVE_INACTIVE}${id}?activate=${is_active}`),
    },

    // ================= Skill Program =================
    skillProgram: {
      // -------- Program Types --------
      getProgramTypes: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data
        let queryParams = []
        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
        return instance.get(`${Config.SKILL_PROGRAM_TYPES}${queryString}`)
      },

      addProgramType: (data) => instance.post(Config.SKILL_PROGRAM_TYPES, data),

      updateProgramType: ({ id, ...data }) =>
        instance.put(`${Config.SKILL_PROGRAM_TYPES}${id}/`, data),

      toggleProgramTypeStatus: ({ id, is_active }) =>
        instance.patch(`${Config.SKILL_PROGRAM_TYPES}${id}/status/?activate=${is_active}`),
      deleteProgramType: ({ id }) => instance.delete(`${Config.SKILL_PROGRAM_TYPES}${id}/`),
      // ================= Skill Super Category =================
      getSkillSuperCategoryList: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data
        let queryParams = []
        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)
        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
        return instance.get(`${Config.SKILL_PROGRAM_SUPER_CATEGORY}${queryString}`)
      },

      getSkillSuperCategoryDetails: ({ id }) =>
        instance.get(`${Config.SKILL_PROGRAM_SUPER_CATEGORY}${id}/`),

      addSkillSuperCategory: (data) => instance.post(Config.SKILL_PROGRAM_SUPER_CATEGORY, data),

      updateSkillSuperCategory: ({ id, ...data }) =>
        instance.put(`${Config.SKILL_PROGRAM_SUPER_CATEGORY}${id}/`, data),

      deleteSkillSuperCategory: ({ id }) =>
        instance.delete(`${Config.SKILL_PROGRAM_SUPER_CATEGORY}${id}/`),

      activeInactiveSkillSuperCategory: ({ id, is_active }) =>
        instance.patch(`${Config.SKILL_PROGRAM_SUPER_CATEGORY}${id}/status/?activate=${is_active}`),

      // -------- Category --------
      getCategory: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data
        let queryParams = []
        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
        return instance.get(`${Config.SKILL_PROGRAM_CATEGORY}${queryString}`)
      },

      addCategory: (data) => instance.post(Config.SKILL_PROGRAM_CATEGORY, data),

      updateCategory: ({ id, ...data }) =>
        instance.put(`${Config.SKILL_PROGRAM_CATEGORY}${id}/`, data),

      toggleCategoryStatus: ({ id, is_active }) =>
        instance.patch(`${Config.SKILL_PROGRAM_CATEGORY}${id}/status/?activate=${is_active}`),
      deleteCategory: ({ id }) => instance.delete(`${Config.SKILL_PROGRAM_CATEGORY}${id}/`),

      // -------- Sub Category --------
      getSubCategory: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data
        let queryParams = []
        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
        return instance.get(`${Config.SKILL_PROGRAM_SUB_CATEGORY}${queryString}`)
      },

      addSubCategory: (data) => instance.post(Config.SKILL_PROGRAM_SUB_CATEGORY, data),

      updateSubCategory: ({ id, ...data }) =>
        instance.put(`${Config.SKILL_PROGRAM_SUB_CATEGORY}${id}/`, data),

      toggleSubCategoryStatus: ({ id, is_active }) =>
        instance.patch(`${Config.SKILL_PROGRAM_SUB_CATEGORY}${id}/status/?activate=${is_active}`),
      deleteSubCategory: ({ id }) => instance.delete(`${Config.SKILL_PROGRAM_SUB_CATEGORY}${id}/`),

      // -------- LIST --------
      getSkillProgramList: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data

        let queryParams = []
        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''

        return instance.get(`${Config.SKILL_PROGRAM_LIST}${queryString}`)
      },

      // -------- DETAILS --------
      getSkillProgramDetails: (id) =>
        instance.get(`${Config.SKILL_PROGRAM_DETAILS}${id}?include_inactive=true`),
      deleteSkillProgram: ({ id }) => instance.delete(`${Config.SKILL_PROGRAM_LIST}${id}/`),
      getAppliedSkillList: (data = {}) => {
        const { page, pageSize, urlAddOn = '' } = data

        let queryParams = []
        if (page !== undefined) queryParams.push(`page=${page}`)
        if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
        if (urlAddOn) queryParams.push(urlAddOn)

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''

        return instance.get(`${Config.SKILL_PROGRAM_APPLIED_LIST}${queryString}`)
      },

      getAppliedSkillDetails: (id) => instance.get(`${Config.SKILL_PROGRAM_APPLIED_DETAILS}${id}/`),
    },
  },
  orderManageMent: {
    getOrderList: (data) => {
      let last = `page=${data?.page}&size=${data?.pageSize}${data?.urlAddOn || ''}`

      return instance.get(`${Config.ORDER_URL}?${last}`)
    },
    getOrderListDetailsList: (id) => instance.get(`${Config.ORDER_URL}?order_id=${id}`),
  },

  jobManagement: {
    getJobCategoryList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.JOB_CATEGORY_LIST}${queryString}`
      return instance.get(url)
    },
    addJobCategoryList: (data) => instance.post(Config.ADD_JOB_CATEGORY, data),
    updateJobCategoryList: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_JOB_CATEGORY}${id}/`, data),

    deleteJobCategory: ({ id }) => instance.delete(`${Config.DELETE_JOB_CATEGORY}${id}/`),
    getJobSubCategoryList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.JOB_SUB_CATEGORY_LIST}${queryString}`
      return instance.get(url)
    },
    addJobSubCategoryList: (data) => instance.post(Config.ADD_JOB_SUB_CATEGORY, data),
    updateJobSubCategoryList: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_JOB_SUB_CATEGORY}${id}/`, data),

    deleteJobSubCategory: ({ id }) => instance.delete(`${Config.DELETE_JOB_SUB_CATEGORY}${id}/`),

    getJobTagList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.JOB_TAG_LIST}${queryString}`
      return instance.get(url)
    },

    getJobTagById: ({ id }) => instance.get(`${Config.JOB_TAG_BY_ID}${id}/`),

    addJobTag: (data) => instance.post(Config.CREATE_JOB_TAG, data),

    updateJobTag: ({ id, ...data }) => instance.put(`${Config.UPDATE_JOB_TAG}${id}/`, data),

    deleteJobTag: ({ id }) => instance.delete(`${Config.DELETE_JOB_TAG}${id}/`),

    activeInactiveJobTag: ({ id, is_active }) =>
      instance.patch(`${Config.JOB_TAG_ACTIVE_INACTIVE}${id}/?activate=${is_active}`),

    // ================= JOB LISTING =================

    getJobUserList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.JOB_USER_LIST}${queryString}`)
    },

    getJobUserDetails: (id) => {
      return instance.get(`${Config.JOB_USER_LIST_DETAILS}?job_id=${id}`)
    },

    getJobSeekerAppliedList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.JOB_SEEKER_APPLIED_LIST}${queryString}`)
    },

    getStoreJobList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.STORE_JOB_LIST}${queryString}`)
    },

    getStoreJobApplications: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.STORE_JOB_APPLICATION_LIST}${queryString}`)
    },
    // ================= Job Category =================

    activeInactiveJobCategory: ({ id, is_active }) =>
      instance.patch(`${Config.JOB_CATEGORY_ACTIVE_INACTIVE}${id}/?activate=${is_active}`),

    // ================= Job Sub Category =================

    activeInactiveJobSubCategory: ({ id, is_active }) =>
      instance.patch(`${Config.JOB_SUB_CATEGORY_ACTIVE_INACTIVE}${id}/?activate=${is_active}`),

    // ================= Job Seeker Resume =================

    getJobSeekerResumeList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []

      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''

      return instance.get(`${Config.JOB_SEEKER_RESUME_LIST}${queryString}`)
    },

    // Resume View
    getJobSeekerResumeDetails: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []

      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''

      return instance.get(`${Config.JOB_SEEKER_RESUME_DETAILS}${queryString}`)
    },
  },
  otherService: {
    getStoreProductList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.PRODUCT_LIST}${queryString}`
      return instance.get(url)
    },
    addStoreProductList: (data) => instance.post(Config.ADD_PRODUCT, data),
    updateStoreProductList: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_PRODUCT}${id}/`, data),
    deleteStoreProductListItem: ({ id }) => instance.delete(`${Config.DELETE_PRODUCT}${id}/`),
    getStoreProductDetailsList: ({ id }) =>
      instance.get(`${Config.PRODUCT_DETAILS}?product_id=${id}`),
    productStatusChange: ({ id, is_active }) =>
      instance.patch(`${Config.PRODUCT_STATUS_CHANGE}${id}/?activate=${is_active}`),

    // Admin Product
    getAdminProductList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) {
        queryParams.push(`page=${page}`)
      }
      if (pageSize !== undefined) {
        queryParams.push(`size=${pageSize}`)
      }
      if (urlAddOn) {
        queryParams.push(urlAddOn)
      }
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.ADMIN_PRODUCT_LIST}${queryString}`
      return instance.get(url)
    },
    addAdminProductList: (data) => instance.post(Config.ADMIN_ADD_PRODUCT, data),
    updateAdminProductList: ({ id, ...data }) =>
      instance.put(`${Config.ADMIN_UPDATE_PRODUCT}${id}/`, data),
    deleteAdminProductListItem: ({ id }) => instance.delete(`${Config.ADMIN_DELETE_PRODUCT}${id}/`),
    getAdminProductDetailsList: ({ id }) =>
      instance.get(`${Config.ADMIN_LIST_PRODUCT_DETAILS}?product_id=${id}`),
    adminProductStatusChange: ({ id, is_active }) =>
      instance.patch(`${Config.ADMIN_PRODUCT_STATUS_CHANGE}${id}/?activate=${is_active}`),

    // Add Bulk Product

    addBulkProductByExcel: ({ params, formDataToSubmit }) => {
      // Construct the base URL with state_id and city_id
      let url = `${Config.BULK_UPLOAD_PRODUCT_BY_EXCEL}?state_id=${params.state_id}&city_id=${params.city_id}&store_id=${params.store_id}`

      if (params.store_type_id) {
        url += `&store_type_id=${params.store_type_id}`
      }

      // Send the POST request with the multipart form data
      return multiPartInstance.post(url, formDataToSubmit, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    },
  },

  marketPlaceApi: {
    // ================= Super Category =================
    getSuperCategoryList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.MARKETPLACE_SUPER_CATEGORY}${queryString}`
      return instance.get(url)
    },

    getSuperCategoryDetails: ({ id }) => instance.get(`${Config.MARKETPLACE_SUPER_CATEGORY}${id}/`),

    addSuperCategory: (data) => instance.post(Config.MARKETPLACE_SUPER_CATEGORY, data),

    updateSuperCategory: ({ id, ...data }) =>
      instance.put(`${Config.MARKETPLACE_SUPER_CATEGORY}${id}/`, data),
    deleteSuperCategory: ({ id }) => instance.delete(`${Config.MARKETPLACE_SUPER_CATEGORY}${id}/`),

    activeInactiveSuperCategory: ({ id, is_active }) =>
      instance.patch(`${Config.MARKETPLACE_SUPER_CATEGORY}${id}/status?activate=${is_active}`),

    getCategoryList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.MARKETPLACE_CATEGORY_LIST}${queryString}`
      return instance.get(url)
    },

    getCategoryDetails: ({ id }) =>
      instance.get(`${Config.MARKETPLACE_CATEGORY_DETAILS}?category_id=${id}`),

    addCategory: (data) => instance.post(Config.ADD_MARKETPLACE_CATEGORY, data),

    updateCategory: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_MARKETPLACE_CATEGORY}${id}/`, data),

    deleteCategory: ({ id }) => instance.delete(`${Config.DELETE_MARKETPLACE_CATEGORY}${id}/`),

    // Sub Category

    getSubcategoryList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.MARKETPLACE_SUBCATEGORY_LIST}${queryString}`
      return instance.get(url)
    },

    addSubcategory: (data) => instance.post(Config.ADD_MARKETPLACE_SUBCATEGORY, data),

    getSubcategoryDetails: ({ id }) =>
      instance.get(`${Config.MARKETPLACE_SUBCATEGORY_DETAILS}?sub_category_id=${id}`),

    updateSubcategory: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_MARKETPLACE_SUBCATEGORY}${id}/`, data),

    deleteSubcategory: ({ id }) =>
      instance.delete(`${Config.DELETE_MARKETPLACE_SUB_CATEGORY}${id}/`),

    // brand

    getBrandList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.MARKETPLACE_BRAND_LIST}${queryString}`
      return instance.get(url)
    },

    getBrandDetails: ({ id }) => instance.get(`${Config.MARKETPLACE_BRAND_DETAILS}?brand_id${id}`),

    addBrand: (data) => instance.post(Config.ADD_MARKETPLACE_BRAND, data),

    updateBrand: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_MARKETPLACE_BRAND}${id}/`, data),

    deleteBrand: ({ id }) => instance.delete(`${Config.DELETE_MARKETPLACE_BRAND}${id}/`),

    // Marketplace Products

    getProductList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.MARKETPLACE_PRODUCT_LIST}${queryString}`

      return instance.get(url)
    },

    getProductDetails: (id) =>
      instance.get(`${Config.MARKETPLACE_PRODUCT_DETAILS}?product_id=${id}`),
  },

  ServiceManagement: {
    getServiceList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.SERVICE_LIST}${queryString}`
      return instance.get(url)
    },

    getServiceDetails: ({ id }) => instance.get(`${Config.SERVICE_LIST}${id}/`),
    activeInactiveStoreServicesList: ({ id, is_active }) =>
      instance.patch(`${Config.STORE_SERVICE_ACTIVE_INACTIVE}${id}/?activate=${is_active}`),

    addService: (data) => instance.post(Config.ADD_SERVICE, data),

    updateService: ({ id, ...data }) => instance.put(`${Config.UPDATE_SERVICE}${id}/`, data),

    deleteService: ({ id }) => instance.delete(`${Config.DELETE_SERVICE}${id}/`),
  },

  healthcareManagement: {
    // ---------------- Doctor List ----------------
    getDoctorList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.DOCTOR_LIST}${queryString}`
      return instance.get(url)
    },
    getDoctorDetails: (doctorId) => instance.get(`${Config?.DOCTOR_DETAILS_API}${doctorId}/`),

    doctorStatusChange: ({ id, is_active }) =>
      instance.patch(`${Config.DOCTOR_ACTIVE_INACTIVE}${id}/?activate=${is_active}`),

    // ---------------- Doctor Specification ----------------
    getDoctorSpecificationList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''
      const url = `${Config.DOCTOR_SPECIFICATION_LIST}${queryString}`
      return instance.get(url)
    },

    addDoctorSpecification: (data) => instance.post(Config.ADD_DOCTOR_SPECIFICATION, data),

    updateDoctorSpecification: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_DOCTOR_SPECIFICATION}${id}/`, data),

    doctorSpecificationStatusChange: ({ id, is_active }) =>
      instance.patch(`${Config.DOCTOR_SPECIFICATION_ACTIVE_INACTIVE}${id}/?activate=${is_active}`),
  },

  eventManagement: {
    // List Event Categories
    getEventCategoryList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []

      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.EVENT_CATEGORY}${queryString}`)
    },

    // Get Event Category Details
    getEventCategoryDetails: ({ id }) => instance.get(`${Config.EVENT_CATEGORY}${id}/`),

    // Add Event Category
    addEventCategory: (data) => instance.post(Config.ADD_EVENT_CATEGORY, data),

    // Update Event Category
    updateEventCategory: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_EVENT_CATEGORY}${id}/`, data),

    // ✅ Activate / Deactivate (SAME URL)
    activeInactiveEventCategory: ({ id, is_active }) =>
      instance.patch(`${Config.EVENT_CATEGORY_ACTIVE_INACTIVE}${id}?activate=${is_active}`),

    // ================= Event Sub Category =================

    getEventSubCategoryList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []

      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.EVENT_SUB_CATEGORY_LIST}${queryString}`)
    },

    getEventSubCategoryDetails: ({ id }) =>
      instance.get(`${Config.EVENT_SUB_CATEGORY_DETAILS}${id}`),

    addEventSubCategory: (data) => instance.post(Config.ADD_EVENT_SUB_CATEGORY, data),

    updateEventSubCategory: ({ id, ...data }) =>
      instance.put(`${Config.UPDATE_EVENT_SUB_CATEGORY}${id}`, data),

    activeInactiveEventSubCategory: ({ id, is_active }) =>
      instance.patch(`${Config.EVENT_SUB_CATEGORY_ACTIVE_INACTIVE}${id}?activate=${is_active}`),

    // ---------------- Event List ----------------
    getEventList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []

      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.EVENT_LIST}${queryString}`)
    },

    // ---------------- View Event Details ----------------
    getEventDetails: ({ id }) => {
      return instance.get(`${Config.EVENT_LIST_DETAILS}${id}`)
    },
    getEventRegisterUserList: (data) => {
      const { event_id, page = 1, size = 50 } = data
      return instance.get(
        `${Config.EVENT_REGISTER_USER_LIST}?event_id=${event_id}&page=${page}&size=${size}`,
      )
    },

    // ✅ Update Event (PUT)
    updateEvent: ({ id, data }) => {
      return instance.put(`${Config.UPDATE_EVENT}${id}`, data)
    },

    // ✅ Active / Inactive Event (PATCH)
    activeInactiveEvent: ({ id, is_active }) => {
      return instance.patch(`${Config.ACTIVE_INACTIVE_EVENT}${id}/?is_active=${is_active}`)
    },
  },

  // ================= Gig Module =================
  gigManagement: {
    // -------- Super Category --------
    getGigSuperCategoryList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.GIG_SUPER_CATEGORY}${queryString}`)
    },

    getGigSuperCategoryDetails: ({ id }) => instance.get(`${Config.GIG_SUPER_CATEGORY}${id}/`),

    addGigSuperCategory: (data) => instance.post(Config.GIG_SUPER_CATEGORY, data),

    updateGigSuperCategory: ({ id, ...data }) =>
      instance.put(`${Config.GIG_SUPER_CATEGORY}${id}/`, data),

    deleteGigSuperCategory: ({ id }) => instance.delete(`${Config.GIG_SUPER_CATEGORY}${id}/`),

    toggleGigSuperCategoryStatus: ({ id, is_active }) =>
      instance.patch(`${Config.GIG_SUPER_CATEGORY}${id}/status/?activate=${is_active}`),

    // -------- Category --------
    getGigCategoryList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.GIG_CATEGORY}${queryString}`)
    },

    addGigCategory: (data) => instance.post(Config.GIG_CATEGORY, data),

    updateGigCategory: ({ id, ...data }) => instance.put(`${Config.GIG_CATEGORY}${id}/`, data),

    deleteGigCategory: ({ id }) => instance.delete(`${Config.GIG_CATEGORY}${id}/`),

    toggleGigCategoryStatus: ({ id, is_active }) =>
      instance.patch(`${Config.GIG_CATEGORY}${id}/status/?activate=${is_active}`),

    // -------- Sub Category --------
    getGigSubCategoryList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.GIG_SUB_CATEGORY}${queryString}`)
    },

    addGigSubCategory: (data) => instance.post(Config.GIG_SUB_CATEGORY, data),

    updateGigSubCategory: ({ id, ...data }) =>
      instance.put(`${Config.GIG_SUB_CATEGORY}${id}/`, data),

    deleteGigSubCategory: ({ id }) => instance.delete(`${Config.GIG_SUB_CATEGORY}${id}/`),

    toggleGigSubCategoryStatus: ({ id, is_active }) =>
      instance.patch(`${Config.GIG_SUB_CATEGORY}${id}/status/?activate=${is_active}`),

    // -------- Gig Profile LIST --------
    getGigProfileList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.GIG_PROFILE_LIST}${queryString}`)
    },

    // -------- Gig Profile DETAILS --------
    getGigProfileDetails: (id) => instance.get(`${Config.GIG_PROFILE_DETAILS}${id}/`),

    // -------- Create --------
    createGigProfile: (data) => instance.post(Config.GIG_PROFILE_LIST, data),

    // -------- Update --------
    updateGigProfile: ({ id, ...data }) => instance.put(`${Config.GIG_PROFILE_LIST}${id}/`, data),

    // -------- Delete --------
    deleteGigProfile: ({ id }) => instance.delete(`${Config.GIG_PROFILE_LIST}${id}/`),

    // -------- Toggle Availability --------
    toggleGigAvailability: ({ id, is_available }) =>
      instance.patch(`${Config.GIG_PROFILE_LIST}${id}/availability/?available=${is_available}`),
    gigHireList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data

      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)

      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.GIG_HIRE_LIST}${queryString}`)
    },
  },

  cmsApi: {
    addPages: (data) => instance.post(Config.CMS_VIEW, data),
    getPages: (data) => {
      let last = data?.page || data?.pageSize ? `page=${data?.page}&size=${data?.pageSize}` : ''
      return instance.get(`${Config.CMS_VIEW}?${last}`)
    },
    editPages: ({ id, ...data }) => instance.put(`${Config.CMS_VIEW}${id}`, data),
    deletePages: (page_id) => instance.delete(`${Config.CMS_VIEW}${page_id}`),
    pageDetails: (page_name) => instance.get(`${Config.CMS_VIEW}${page_name}`),
  },

  vehicleManagement: {
    // ================= VEHICLE TYPE =================
    getVehicleTypeList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.VEHICLE_TYPE}${queryString}`)
    },

    getVehicleTypeDetails: ({ id }) => instance.get(`${Config.VEHICLE_TYPE}${id}`),

    addVehicleType: (data) => instance.post(Config.VEHICLE_TYPE, data),

    updateVehicleType: ({ id, ...data }) => instance.put(`${Config.VEHICLE_TYPE}${id}`, data),

    deleteVehicleType: ({ id }) => instance.delete(`${Config.VEHICLE_TYPE}${id}`),

    toggleVehicleTypeStatus: ({ id, is_active }) =>
      instance.patch(`${Config.VEHICLE_TYPE}${id}/status?activate=${is_active}`),

    // ================= VEHICLE FACILITY =================
    getVehicleFacilityList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.VEHICLE_FACILITY}${queryString}`)
    },

    getVehicleFacilityDetails: ({ id }) => instance.get(`${Config.VEHICLE_FACILITY}${id}`),

    addVehicleFacility: (data) => instance.post(Config.VEHICLE_FACILITY, data),

    updateVehicleFacility: ({ id, ...data }) =>
      instance.put(`${Config.VEHICLE_FACILITY}${id}`, data),

    deleteVehicleFacility: ({ id }) => instance.delete(`${Config.VEHICLE_FACILITY}${id}`),

    toggleVehicleFacilityStatus: ({ id, is_active }) =>
      instance.patch(`${Config.VEHICLE_FACILITY}${id}/status?activate=${is_active}`),

    // ================= VEHICLE CATEGORY =================
    getVehicleCategoryList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.VEHICLE_CATEGORY}${queryString}`)
    },

    addVehicleCategory: (data) => instance.post(Config.VEHICLE_CATEGORY, data),

    updateVehicleCategory: ({ id, ...data }) =>
      instance.put(`${Config.VEHICLE_CATEGORY}${id}/`, data),

    deleteVehicleCategory: ({ id }) => instance.delete(`${Config.VEHICLE_CATEGORY}${id}/`),

    toggleVehicleCategoryStatus: ({ id, is_active }) =>
      instance.patch(`${Config.VEHICLE_CATEGORY}${id}/status/?activate=${is_active}`),

    // ================= VEHICLE SUBCATEGORY =================
    getVehicleSubCategoryList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.VEHICLE_SUBCATEGORY}${queryString}`)
    },

    addVehicleSubCategory: (data) => instance.post(Config.VEHICLE_SUBCATEGORY, data),

    updateVehicleSubCategory: ({ id, ...data }) =>
      instance.put(`${Config.VEHICLE_SUBCATEGORY}${id}/`, data),

    deleteVehicleSubCategory: ({ id }) => instance.delete(`${Config.VEHICLE_SUBCATEGORY}${id}/`),

    toggleVehicleSubCategoryStatus: ({ id, is_active }) =>
      instance.patch(`${Config.VEHICLE_SUBCATEGORY}${id}/status/?activate=${is_active}`),

    getDriverList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.VEHICLE_DRIVER_LIST}${queryString}`)
    },

    getDriverDetails: ({ id }) => instance.get(`${Config.VEHICLE_DRIVER_LIST}${id}/`),

    // ================= VEHICLES =================
    getVehicleList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.VEHICLE_LIST}${queryString}`)
    },

    getVehicleDetails: ({ id }) => instance.get(`${Config.VEHICLE_DETAILS}${id}/`),

    addVehicle: (data) => instance.post(Config.VEHICLE_LIST, data),

    updateVehicle: ({ id, ...data }) => instance.put(`${Config.VEHICLE_DETAILS}${id}/`, data),

    deleteVehicle: ({ id }) => instance.delete(`${Config.VEHICLE_DETAILS}${id}/`),

    toggleVehicleStatus: ({ id, is_active }) =>
      instance.patch(`${Config.VEHICLE_DETAILS}${id}/status/?activate=${is_active}`),

    // ================= VEHICLE SOS ALERTS =================
    getVehicleSosList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.VEHICLE_SOS}${queryString}`)
    },

    getVehicleSosDetails: ({ id }) => instance.get(`${Config.VEHICLE_SOS}${id}/`),

    resolveVehicleSos: ({ id, ...data }) =>
      instance.patch(`${Config.VEHICLE_SOS}${id}/resolve/`, data),
  },

  feedbackManagement: {
    // ================= FEEDBACK TYPE MANAGEMENT =================
    getFeedbackTypeList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.FEEDBACK_TYPE}${queryString}`)
    },

    getFeedbackTypeDetails: ({ id }) => instance.get(`${Config.FEEDBACK_TYPE}${id}`),

    addFeedbackType: (data) => instance.post(Config.FEEDBACK_TYPE, data),

    updateFeedbackType: ({ id, ...data }) => instance.put(`${Config.FEEDBACK_TYPE}${id}`, data),

    deleteFeedbackType: ({ id }) => instance.delete(`${Config.FEEDBACK_TYPE}${id}`),

    toggleFeedbackTypeStatus: ({ id, is_active }) =>
      instance.patch(`${Config.FEEDBACK_TYPE}${id}/status?activate=${is_active}`),

    // ================= USER FEEDBACK =================
    getUserFeedbackList: (data = {}) => {
      const { page, pageSize, urlAddOn = '' } = data
      let queryParams = []
      if (page !== undefined) queryParams.push(`page=${page}`)
      if (pageSize !== undefined) queryParams.push(`size=${pageSize}`)
      if (urlAddOn) queryParams.push(urlAddOn)
      const queryString = queryParams.length ? `?${queryParams.join('&')}` : ''
      return instance.get(`${Config.USER_FEEDBACK}${queryString}`)
    },

    getUserFeedbackDetails: ({ id }) => instance.get(`${Config.USER_FEEDBACK}${id}`),

    updateUserFeedbackStatus: ({ id, status }) =>
      instance.patch(`${Config.USER_FEEDBACK}${id}/status?status=${status}`),
  },
}
